import { Box, Chip, Tooltip, Typography } from '@material-ui/core';
import { blue, green, grey, orange, purple, red, teal } from '@material-ui/core/colors';
import CopyClipboard from '@material-ui/icons/AttachFile';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { startCase } from 'lodash';
import { useState } from 'react';

const STATUS_COLORS: Record<string, string> = {
  verified: green[700],
  extrapolated: orange[800],
  unavailable: red[700],
  guessed: teal[700],
  unverified: grey[700],
};

const OTHER_STATUS_COLORS = [blue[700], purple[600], teal[600], orange[700]];

const apolloStatusPresentation = (status: string) => {
  const key = status.trim().toLowerCase();
  const color =
    STATUS_COLORS[key] ||
    OTHER_STATUS_COLORS[
      key.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0) % OTHER_STATUS_COLORS.length
    ];

  return {
    label: `Apollo ${startCase(key)}`,
    color,
  };
};

export const EmailCopy = ({ value }: { value: string }) => {
  const [isHovering, setHovering] = useState(false);
  const [isCopied, setCopied] = useState(false);

  return (
    <span
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => {
        setCopied(false);
        setTimeout(() => setHovering(false), 500);
      }}>
      <Typography variant="body2" component="span" style={{ fontWeight: 600 }}>
        {value}
      </Typography>
      <span style={{ display: isHovering ? 'inline' : 'none', marginLeft: 4 }}>
        <Tooltip title={isCopied ? 'Copied!!' : 'Copy the Email Id'}>
          <span
            style={{ cursor: 'pointer' }}
            onClick={() => {
              navigator.clipboard.writeText(value);
              setCopied(true);
            }}>
            <CopyClipboard style={{ fontSize: '1em' }} color="primary" />
          </span>
        </Tooltip>
      </span>
    </span>
  );
};

export const EmailStatusChips = ({ status }: { status?: string | null }) => {
  const statuses = (status || '')
    .split(',')
    .map(item => item.trim())
    .filter(Boolean);

  if (!statuses.length) {
    return (
      <Typography variant="body2" color="textSecondary">
        -
      </Typography>
    );
  }

  return (
    <Box display="flex" flexWrap="wrap" style={{ gap: 4 }}>
      {statuses.map(item => {
        const presentation = apolloStatusPresentation(item);
        return (
          <Chip
            key={item}
            size="small"
            variant="outlined"
            label={presentation.label}
            style={{
              color: presentation.color,
              borderColor: presentation.color,
              height: 20,
              fontSize: 11,
              fontWeight: 500,
            }}
          />
        );
      })}
    </Box>
  );
};

export const DbExistsMark = ({ dbExists }: { dbExists?: boolean | null }) => {
  if (dbExists) {
    return (
      <Tooltip title="Exists">
        <span>
          <CheckCircleIcon style={{ color: green[600], fontSize: '1.4rem' }} />
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Does not exist">
      <span>
        <CancelIcon style={{ color: red[600], fontSize: '1.4rem' }} />
      </span>
    </Tooltip>
  );
};
